import { useEffect, useRef } from 'react'

export default function HandSummaryDialog({ summary, score, onNextHand }) {
  const dialogRef = useRef(null)
  const previousFocus = useRef(null)

  useEffect(() => {
    if (summary) {
      previousFocus.current = document.activeElement
      const firstBtn = dialogRef.current?.querySelector('button')
      if (firstBtn) firstBtn.focus()
    } else if (previousFocus.current) {
      previousFocus.current.focus()
      previousFocus.current = null
    }
  }, [summary])

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key !== 'Tab') return
      const dialog = dialogRef.current
      if (!dialog) return
      const focusable = dialog.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      const first = focusable[0]
      const last = focusable[focusable.length - 1]
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault()
        last.focus()
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault()
        first.focus()
      }
    }

    if (summary) {
      window.addEventListener('keydown', handleKeyDown)
      return () => window.removeEventListener('keydown', handleKeyDown)
    }
  }, [summary])

  if (!summary) return null

  const winnerText = summary.winner === 'jogador' ? 'Você' : 'O computador'
  const text = `${summary.reason} ${winnerText} recebeu ${summary.points_awarded} ponto(s). Placar: Você ${score.player} × ${score.bot} Computador.`

  return (
    <div
      ref={dialogRef}
      id="hand-summary-dialog"
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="hand-summary-heading"
    >
      <div className="modal-content">
        <h2 id="hand-summary-heading">Fim da mão</h2>
        <p id="hand-summary-text">{text}</p>
        <div className="modal-actions">
          <button
            type="button"
            className="btn btn-primary btn-large"
            id="btn-next-hand"
            onClick={onNextHand}
          >
            Próxima mão
          </button>
        </div>
      </div>
    </div>
  )
}
